import { nextTick } from 'vue'
import { defineStore } from 'pinia'

export const useListStore = defineStore('list', {
  state: () => ({
    modelList: []
  }),
  actions: {
    handleTooltips() {
      nextTick(() => {
        const tooltips = document.querySelectorAll('[data-mdb-tooltip-init]')
        tooltips.forEach(tooltip => {
          let isTextTruncated = false
          const el = tooltip.firstElementChild
          const text = (el?.textContent || '').trim()
          if (text) {
            const range = document.createRange()
            range.selectNodeContents(el)
            const textWidth = range.getBoundingClientRect().width
            const boxWidth = tooltip.getBoundingClientRect().width
            isTextTruncated = textWidth > boxWidth
          }
          if (!isTextTruncated) {
            isTextTruncated =
              Math.max(tooltip.offsetWidth, tooltip.scrollWidth) > tooltip.clientWidth
          }
          const tooltipInstance = mdb.Tooltip.getInstance(tooltip)
          if (!isTextTruncated) {
            tooltipInstance?.dispose()
            tooltip.removeAttribute('title')
            tooltip.removeAttribute('data-mdb-original-title')
          } else if (!tooltipInstance) {
            tooltip.setAttribute('title', tooltip.innerText)
            new mdb.Tooltip(tooltip)
          }
        })
      })
    }
  }
})
